<template>
  <v-col v-bind="$attrs">
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "AppColumn",
};
</script>
